var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-5"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"montserrat-bold mb-3"},[_vm._v(_vm._s(_vm.heading))]),_c('section',{staticClass:"mb-4"},[_vm._t("content")],2),_c('footer',[_vm._t("footer")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }